const updateQtyGrid = variants => {
  const $inputs = document.querySelectorAll(
    ".js-product-details-quantity-form input[data-variant-id]"
  );

  $inputs.forEach($input => {
    const { variantId } = $input.dataset;
    const variantData = variants[variantId];
    if (!variantData?.quantity) return;

    const inputEvent = new InputEvent("input", {
      view: window,
      bubbles: true
    });
    const changeEvent = new InputEvent("change", {
      view: window,
      bubbles: true
    });

    $input.value = variantData.quantity;
    $input.dispatchEvent(inputEvent);
    $input.dispatchEvent(changeEvent);
  });
};

export const prefillVariantInputs = variants => {
  if (!variants) return;

  if (window.dynamicDataLoaded) {
    updateQtyGrid(variants);
    return;
  }

  document.addEventListener(
    "dynamicDataLoaded",
    () => {
      updateQtyGrid(variants);
    },
    false
  );
};

export default { prefillVariantInputs };
